import React, { useState } from 'react';
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_SERVICE_KEY = process.env.REACT_APP_SUPABASE_SERVICE_KEY;
const CORRECT_PIN = process.env.REACT_APP_FOOD_LOG_PIN;

const adminSupabase = createClient(SUPABASE_URL, SUPABASE_SERVICE_KEY);

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

function ymd(d) {
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}
function fmtDate(iso) {
  const d = new Date(iso + 'T00:00:00');
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export default function FoodLog() {
  const [screen, setScreen] = useState('pin');
  const [pin, setPin] = useState('');
  const [pinError, setPinError] = useState('');
  const [date, setDate] = useState(ymd(new Date()));
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [publicUrl, setPublicUrl] = useState('');
  const [copied, setCopied] = useState(false);

  function handlePin(e) {
    e.preventDefault();
    if (pin === CORRECT_PIN) {
      setScreen('upload');
    } else {
      setPinError('Wrong PIN');
    }
  }

  function handleFileSelect(e) {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f);
    setPreview(URL.createObjectURL(f));
    setUploadError('');
  }

  async function handleUpload() {
    if (!file) return;
    setUploading(true);
    setUploadError('');
    try {
      const path = `${date}.jpg`;
      const { error } = await adminSupabase.storage
        .from('food')
        .upload(path, file, { contentType: file.type, upsert: true });
      if (error) throw new Error(error.message);

      setPublicUrl(`${SUPABASE_URL}/storage/v1/object/public/food/${path}`);
      setScreen('success');
    } catch (err) {
      setUploadError(err.message);
    } finally {
      setUploading(false);
    }
  }

  async function copyUrl() {
    await navigator.clipboard.writeText(publicUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  if (screen === 'pin') {
    return (
      <div className="fl-page">
        <h1 className="fl-title">Lunch Log</h1>
        <form className="fl-form" onSubmit={handlePin}>
          <input
            className="fl-pin-input"
            type="password"
            inputMode="numeric"
            value={pin}
            onChange={e => setPin(e.target.value)}
            placeholder="Enter PIN"
            autoFocus
          />
          {pinError && <p className="fl-error">{pinError}</p>}
          <button className="fl-btn" type="submit">Continue</button>
        </form>
        <a className="fl-back" href="/lunch">← Back to diary</a>
      </div>
    );
  }

  if (screen === 'upload') {
    return (
      <div className="fl-page">
        <input
          className="fl-date-input"
          type="date"
          value={date}
          max={ymd(new Date())}
          onChange={e => setDate(e.target.value)}
        />
        <label className="fl-photo-area">
          {preview
            ? <img className="fl-preview" src={preview} alt="" />
            : <span className="fl-photo-hint">Tap to add photo</span>
          }
          <input
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            className="fl-file-input"
          />
        </label>
        {uploadError && <p className="fl-error">{uploadError}</p>}
        {file && (
          <button className="fl-btn" onClick={handleUpload} disabled={uploading}>
            {uploading ? 'Uploading…' : 'Upload'}
          </button>
        )}
        <a className="fl-back" href="/lunch">← Back to diary</a>
      </div>
    );
  }

  return (
    <div className="fl-page">
      <img className="fl-preview" src={preview} alt="" />
      <div className="fl-success-mark">✓</div>
      <p className="fl-success-date">{fmtDate(date)}</p>
      <p className="fl-success-label">Photo uploaded</p>
      <button className="fl-btn" onClick={copyUrl}>
        {copied ? 'Copied!' : 'Copy photo URL'}
      </button>
      <p className="fl-hint">Paste the URL into Claude to log nutrition</p>
      <a className="fl-claude-link fl-btn fl-btn-outline" href="https://claude.ai" target="_blank" rel="noopener noreferrer">
        Open Claude →
      </a>
    </div>
  );
}
